export class CmsConfig {
  baseSite: string;
  apiUrl: string;
  isoCode: string;
  isProductPage: boolean;
  pageId: string;
  productId: string;
  project: 'LR' | 'FS' | 'Dematic' | string;
  basePath: string;
  routes?: any;
  prodPayment?: boolean;
  useProdConcardis?: boolean;
}
